/**
 * Утилиты для работы с числами
 */

/**
 * Форматирует число в сокращенном виде
 * 1000 -> 1к, 1500 -> 1.5к, 1000000 -> 1М
 * @param {number} num - Число для форматирования
 * @returns {string} - Отформатированная строка
 */
export function formatCompactNumber(num) {
  if (typeof num !== 'number' || isNaN(num)) {
    return '0'
  }

  const absNum = Math.abs(num)
  
  if (absNum < 1000) {
    return num.toString()
  }
  
  if (absNum < 1000000) {
    const thousands = num / 1000
    // Если число кратно 1000, показываем без десятичных
    if (Math.abs(thousands % 1) < 0.0001) {
      return `${thousands}к`
    }
    // Иначе показываем с одним знаком после запятой, убираем .0
    return `${thousands.toFixed(1).replace(/\.0$/, '')}к`
  }
  
  // Для миллионов
  const millions = num / 1000000
  if (Math.abs(millions % 1) < 0.0001) {
    return `${millions}М`
  }
  return `${millions.toFixed(1).replace(/\.0$/, '')}М`
}

/**
 * Форматирует число с пробелами для разделения тысяч
 * 1300 -> 1 300, 100000 -> 100 000, 1000000 -> 1 000 000
 * @param {number} num - Число для форматирования
 * @returns {string} - Отформатированная строка
 */
export function formatNumberWithSpaces(num) {
  if (typeof num !== 'number' || isNaN(num)) {
    return '0'
  }

  // Округляем до целого числа
  const rounded = Math.round(num)
  
  // Форматируем с пробелами для разделения тысяч
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

/**
 * Форматирует цену с пробелами для разделения тысяч
 * 1300 -> 1 300, 100000 -> 100 000, 1000000 -> 1 000 000
 * @param {number} price - Цена для форматирования
 * @returns {string} - Отформатированная строка
 */
export function formatPrice(price) {
  return formatNumberWithSpaces(price)
}

